/*
 * export from ngx-lib/core/common/directives
 */
export * from './public-api';
